import React, { PureComponent } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import axios from 'axios';
import appConstant from '../../../constants/app';
import InputComponent from '../../components/baseComponents/input';
import TextareaComponent from '../../components/baseComponents/textarea';

const token = localStorage.getItem('token');

class BannerCreate extends PureComponent {
  state = {
    title: '',
    backgroundType: '1',
    content: '',
    firstDate: '',
    lastDate: '',
    errorMessage: null,
  }

  refFields = {}

  handleInputChange = (val, name) => {
    this.setState({[name]: val});
  }

  handleRadioChange = (event) => {
    this.setState({
      backgroundType: event.target.value
    });
  }

  isValidForm = () => {
    const errorMessage = this.state.firstDate > this.state.lastDate ? "The first date can not be less than the end date": "";
    this.setState({ errorMessage: errorMessage });

    return Object.keys(this.refFields)
      .map(field => this.refFields[field] && this.refFields[field].validate())
      .reduce((sum, validField) => validField != null && sum + (!validField ? 1 : 0), 0) === 0;
  }

  onFormSubmit = (e) => {
    const {
      backgroundType,
      title,
      content,
      firstDate,
      lastDate,
    } = this.state;

    e.preventDefault() // Stop form submit

    if(!this.isValidForm()) return false;

    axios({
      method: 'post',
      url: `${appConstant.API_URL}/banner/create?access_token=${token}`,
      data: {
        background_type: backgroundType,
        title: title,
        content: content,
        first_date: firstDate,
        last_date: lastDate,
      },
    })
    .then(res => {
      this.props.cancel();
    }).catch(err => {
      console.log(err);
    });
  }

  componentDidMount() {
    let today = new Date();
    let dd = today.getDate();
    let mm = today.getMonth() + 1;
    let yyyy = today.getFullYear();

    if(dd < 10) { dd = '0' + dd } 
    if(mm < 10) { mm = '0' + mm } 
    
    today = yyyy+'-'+mm+'-'+dd;
    document.getElementById("first_date").setAttribute("min", today);
    document.getElementById("last_date").setAttribute("min", today);
  }

  render() {
    const {
      title,
      backgroundType,
      content,
      firstDate,
      lastDate,
    } = this.state;

    const {
      cancel,
    } = this.props;

    return (
      <div>
        <Row>
          <Col className="adminbanner-section" sm={8}>
            <div className="title-adminbanner-wrapper">
              <h2 className="title-adminbanner" >Add banner</h2>
            </div>
            <form className="adminbanner-body" onSubmit={this.onFormSubmit}>
              <Row className="background-admin-wrapper">
                <div className="title-background-admin-wrapper">
                  <p className="title-background-admin">
                    Background
                  </p>
                </div>
                <Col className="background-body" sm={12}
                >
                  <div className="option-background" >
                    <div className="option-color-background"
                    ></div>
                    <div className="label-option">
                      <input
                        className="checkbox-option"
                        type="radio"
                        name="background_type"                  
                        value="1"
                        checked={backgroundType === "1"} 
                        onChange={this.handleRadioChange}
                      />
                      <div className="title-option">
                        Gray
                      </div>
                    </div>
                  </div>
                  <div className="option-background" >
                      <div
                        style={{
                          height: '89px',
                          width: '129px',
                          backgroundColor: '#0d1f3f',
                        }}
                      ></div>
                    <div className="label-option">
                      <input
                        className="checkbox-option"
                        type="radio"
                        name="background_type"                  
                        value="2"
                        checked={backgroundType === "2"} 
                        onChange={this.handleRadioChange}
                      />
                      <div className="title-option">
                        Dark Blue
                      </div>
                    </div>
                  </div>
                  <div className="option-background" >
                      <div
                        style={{
                          height: '89px',
                          width: '129px',
                          backgroundColor: '#d0c195',
                        }}
                      ></div>
                    <div className="label-option">
                      <input
                        className="checkbox-option"
                        type="radio"
                        name="background_type"                  
                        value="3"
                        checked={backgroundType === "3"} 
                        onChange={this.handleRadioChange}
                      />
                      <div className="title-option">
                        Gold
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
              <h3 className="title-content-section">Content</h3>
              <Row>
                <Col className="title-input-content" sm={12}>
                  <label className="title-content-input">Title</label>
                  <InputComponent
                    value={title}
                    ref={(input) => { this.refFields.title = input; }}
                    inputGroup="title"
                    placeholder='Title'
                    validationRules="required"
                    customErrorMessage="Required field"                      
                    classes='content-input'
                    onChange={this.handleInputChange}
                    maxLength="80"
                  />
                </Col>
              </Row>
              <Row>
                <Col sm={12}>
                  <label>Content</label>
                  <TextareaComponent
                    value={content}
                    ref={(input) => { this.refFields.content = input; }}
                    inputGroup="content"
                    placeholder="Content"
                    classes='text-area-adminbanner'
                    onChange={this.handleInputChange}
                    validationRules="required"
                    customErrorMessage="Required field"
                    maxLength="500"
                    rich={true}
                    richLink={true}
                  />
                </Col>
              </Row>
              <h3 className="period" >Appearance Period</h3>
              <Row>
                <Col sm={6}>
                  <label>First date</label>
                  <InputComponent
                    value={firstDate}
                    ref={(input) => { this.refFields.firstDate = input; }}
                    inputGroup="firstDate"
                    validationRules="required"
                    customErrorMessage="Required field"
                    placeholder='First date'
                    classes='form-control'
                    onChange={this.handleInputChange}
                    type="date"
                    id="first_date"
                    min=''
                  />
                </Col>
                <Col sm={6}>
                  <label>Last date</label>
                  <InputComponent
                    value={lastDate}
                    ref={(input) => { this.refFields.lastDate = input; }}
                    inputGroup="lastDate"
                    validationRules="required"
                    customErrorMessage="Required field"
                    placeholder='Last date'
                    classes='form-control'
                    onChange={this.handleInputChange}
                    type="date"
                    id="last_date"
                    min=''
                  />
                </Col>
              </Row>
              {this.state.errorMessage && <div className="error-message">{this.state.errorMessage}</div>}
              <Row
                className="buttons-row header-edit-btns">
                <Col sm={12}>
                  <Button
                    className="cancel-btn"
                    onClick={cancel}
                  >
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    className="accept-btn"
                  >
                    Save changes
                  </Button>
                </Col>
              </Row>
            </form>
          </Col>
        </Row>
      </div>
    );
  }
}

export default BannerCreate;


// WEBPACK FOOTER //
// ./src/app/screens/banners/bannerCreate.js